export const absences = {
  loading: "Chargement...",
  error_fetching: "Erreur lors de la récupération des absences.",
  month_year_format: { month: "long", year: "numeric" }, // pour toLocaleString
  legend: {
    validated: "Absences validées",
    not_validated: "Absences non validées",
    weekend: "Week-end",
    holiday: "Jour férié",
  },
  table: {
    title: "Demandes d'absences",
    period: "Période",
    status: "État",
    validated: "✔ Validé",
    pending: "⏳ En attente",
  },
};
